export default function fromUTC(date) {
    // Date will automatically convert the given UTC date to the local timezone.
    return new Date(date);
}
